module.exports = __webpack_public_path__ + "static/media/vbn-custom-2.903aaa25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-custom-2.png
// module id = 479
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 24 27